'use client'

import React from 'react'

/**
 * MLink Props - Compatible with both Next.js Link and standard anchor
 */
export interface IMLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	href: string
	children: React.ReactNode
	/** Standard HTML attributes */
	className?: string
	title?: string
	target?: string
	rel?: string
	/** Accessibility */
	'aria-label'?: string
}

/**
 * MLink - Simple Link Component
 *
 * Uses standard anchor tag for maximum compatibility
 * For Next.js projects, Next.js will automatically handle client-side navigation
 * via their Link component interception
 *
 * @example
 * ```tsx
 * <MLink href="/about">About Us</MLink>
 * ```
 */
export const MLink: React.FC<IMLinkProps> = ({ href, children, ...props }) => {
	return (
		<a href={href} {...props}>
			{children}
		</a>
	)
}

MLink.displayName = 'MLink'
